<div *ngIf="languages.length !== 1" class="language-selector">
    <div class="flag-image">
        <div (click)="displayFlagSelector()" class="actualFlag">
            <img [src]="flagImage" />
            <a><mat-icon aria-hidden="false" aria-label="keyboard_arrow_right icon" fontIcon="keyboard_arrow_down"></mat-icon></a>
        </div>
    </div>
    <div *ngIf="displayFlag" class="flag-selector">
        <div *ngFor="let language of languagesToChange; let i = index" class="flag">
            <button (click)="changeLanguageMobile(language)">
                <img [src]="language.flagImage" />
            </button>
        </div>
    </div>
</div>
